import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { findAll } from "@/apis/subscription";
import Router from "@/constants/router";

import { SubscriptionProductDto } from "@/dto/SubscriptionDto";

export default function useList() {
  const navigate = useNavigate();
  const [list, setList] = useState<SubscriptionProductDto[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const handleGoToCreate = () => {
    navigate(Router.SubscriptionCreate);
  };

  const fetchData = useCallback(async () => {
    try {
      setIsLoading(true);
      const res = await findAll();
      if (res.success) {
        setList(res.data);
      }
    } catch (e) {
      console.error(e);
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return {
    isLoading,
    list,
    handleGoToCreate,
  };
}
